import React from 'react';
import { StaticMapProps } from './StaticMap.types';
import * as Styles from './StaticMap.styles';
import { useConfig } from '../../contexts/ConfigContext/ConfigContext';
import { AcceptCookies } from '../../structure/CookieBanner/CookieBanner';

/**
 * A static Google map with optional markers
 */
const StaticMap: React.FunctionComponent<StaticMapProps> = ({
  centre,
  imageAltText,
  mapMarkers = [],
  mapType = 'roadmap',
  size = '640x320',
  zoom = 14,
  apiKey,
}) => {
  const config = useConfig();
  const resolvedApiKey = apiKey || config.googleMapsApiKey || config.nextPublicGoogleMapsApiKey || '';

  const markerPath = mapMarkers
    .map((mapMarker) => {
      const size = mapMarker.size ?? 'normal';
      const colour = mapMarker.colour ?? 'red';
      const label = mapMarker.label ? `%7Clabel:${mapMarker.label}` : '';

      return `&markers=size:${size}%7Ccolor:${colour}${label}%7C${mapMarker.lat},${mapMarker.lng}`;
    })
    .join('');

  return (
    <Styles.Container data-testid="StaticMap">
      <Styles.Message>
        <span>
          To interact with the map, you need to <Styles.Cookies onClick={AcceptCookies}>accept cookies</Styles.Cookies>.
        </span>
      </Styles.Message>
      <Styles.MapImage
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${centre}&size=${size}&zoom=${zoom}&maptype=${mapType}${markerPath}&key=${resolvedApiKey}`}
        alt={imageAltText}
      />
    </Styles.Container>
  );
};

export default StaticMap;
